import { render } from "./SpecialExpense.vue?vue&type=template&id=653df6ac"
import script from "./SpecialExpense.vue?vue&type=script&lang=js"
export * from "./SpecialExpense.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__